import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'A new chat thread is created on the canvas',
  name: 'canvas_agent_chat_thread_created',
  params: [
    {
      description: 'The ID of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the newly created chat thread',
      name: 'thread_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
